import React, { useState, useEffect } from 'react';
import axios from '../../Axios';
import './Header.css';
import { withRouter, NavLink } from 'react-router-dom';

const Header = ({ history }) => {
  
  useEffect(() => {
  }, []);

  return (
    <div className="main-header-container">
      LoRRI-Profile
    </div>
  );
}

export default withRouter(Header);
